import { EmblaCarouselType } from 'embla-carousel';

function autoplay(embla: EmblaCarouselType, interval: number) {
  let timerId = interval,
    start = Date.now(),
    timer = interval;

  const next = () => {
    if (embla.canScrollNext()) {
      embla.scrollNext();
    } else {
      embla.scrollTo(0);
    }
    start = Date.now();
    timer = interval;
    play();
  };

  const stop = () => {
    window.clearTimeout(timerId);
    timerId = interval;
  };

  const pause = () => {
    window.clearTimeout(timerId);
    timer = interval - Math.min(Date.now() - start, interval);
  };

  const play = () => {
    requestAnimationFrame(() => {
      timerId = window.setTimeout(next, timer);
    });
  };

  const restart = () => {
    start = Date.now();
    timer = interval;
  };

  return {
    play,
    stop,
    pause,
    restart,
  };
}

export default autoplay;
